<template>
  <v-select
    class="lang-select"
    v-model="model"
    flat
    single-line
    dense
    :items="sortList(Getter_Langs_List)"
    item-text="name"
    item-value="id"
    :return-object="true"
    append-icon="mdi-chevron-down"
    outlined
    :menu-props="{ offsetY: true }"
    @change="changeLang"
  ></v-select>
</template>

<script>
import langMixin from './LangMixin';

export default {
  name: 'LangToggleHeader',
  props: {},
  data() {
    return {
      model: '1'
    };
  },
  mixins: [langMixin],
  watch: {
    Getter_Lang(val) {
      if (val) {
        this.model = val.id;
      }
    }
  },
  created() {
    if (this.Getter_Lang) {
      this.model = this.Getter_Lang.id;
    }
  },
  methods: {
    sortList(list) {
      return list.slice().sort((a, b) => (a.code > b.code ? 1 : -1));
    }
  }
};
</script>
<style lang="stylus" scoped>
.v-select.lang-select::v-deep {
  .v-input__control {
    font-size: 0.85rem;
    div {
      margin-bottom: 0;
    }
    fieldset {
      border: none;
    }
    .v-select__selections {
      line-height: 17px;
      .v-select__selection {
        color: #ffffff;
        margin: 0;
        max-width: 100%;
      }
      input {
        display: none;
      }
    }
    .v-input__append-inner {
      align-self: unset;
      margin-top: 0px;
      i {
        color: #ffffff !important;
        margin-top: 0px;
        &.v-icon {
          font-size: 18px;
        }
      }
    }
  }
  .v-text-field__details {
    display: none;
  }
}
</style>
